import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { isDecisionMaker } from './decisionMaker';
import { isGdprConsentProvided } from './gdprConsentProvided';
import { isPolicyAbuseExperimentEnabled } from './isPolicyAbuseExperimentEnabled';

export type PetitionDetailsPageUserData = {
	decisionMaker: boolean;
	gdprConsentProvided: boolean;
	policyAbuseExperimentEnabled: boolean;
};

export async function getPetitionDetailsPageUserData(
	utilityContext: UtilityContext,
	slugOrId: string,
	{ decisionMakerHash, isGuest }: { decisionMakerHash?: string; isGuest: boolean },
): Promise<PetitionDetailsPageUserData> {
	const [decisionMaker, gdprConsentProvided, policyAbuseExperimentEnabled] = await Promise.all([
		!isGuest || decisionMakerHash ? isDecisionMaker(utilityContext, { slugOrId, decisionMakerHash }) : false,
		isGdprConsentProvided(utilityContext),
		isPolicyAbuseExperimentEnabled(utilityContext),
	]);

	return {
		decisionMaker,
		gdprConsentProvided,
		policyAbuseExperimentEnabled,
	};
}
